<template>
  <button type="button" value="Edit" class="xsbtn btn-info">
    <i class="fa-solid fa-pen-to-square"></i>
    Edit
  </button>
</template>

<script>
export default {};
</script>
